module.exports = __webpack_public_path__ + "static/turtle-creek-house49-a25ef4222fb123e9a907d5c6a9e4bf4e.jpg";